<template>
  <b-container>
    <h2>{{ $t("titre_articles") }}</h2>
    <div v-if="articles.length === 0" class="mt-3">
      <p>{{ $t("articles_aucun") }}</p>
    </div>
    <ul v-else>
      <li v-for="article in articles" :key="article.path">
        <router-link :to="'/' + article.path">{{ article.titre }}</router-link>
        <p>
          {{ article.description }}
          <span v-for="cat in parseCategories(article.categorie)" :key="article.path + cat" class="category">
            {{ cat }}
          </span>
          <span v-if="article.annee" class="year"> {{ article.annee }}</span>
        </p>
      </li>
    </ul>
  </b-container>
</template>

<script>
import { getArticles } from "@/api";

export default {
  name: "Articles",
  data() {
    return {
      articles: []
    };
  },
  methods: {
    load() {
      getArticles(this.$i18n.locale).then(response => {
        this.articles = response.data.articles || [];
      });
    },
    parseCategories(cat) {
      if (!cat) return [];
      if (Array.isArray(cat)) return cat;
      return cat.split(",").map(s => s.trim()).filter(Boolean);
    }
  },
  watch: {
    "$i18n.locale"() {
      this.load();
    }
  },
  mounted() {
    this.load();
  }
};
</script>
